module.exports = __webpack_public_path__ + "static/62878c6bf5bc0645609151c8d68879bb38158f6e85482009a036876c1f75f371-aa562051ad767e3c1157f074320f63f2.jpeg";